import { DIVISIONS } from '../mock';

// One primary recipient per enquiry; both admin teams receive a copy.
export const ADMIN_CONTACTS = [
  { label: 'Chiller administration', email: 'admin@fixedchiller.com' },
  { label: 'Logistics administration', email: 'admin@fixedlogistic.com' }
];

export const ENQUIRY_TEAMS = [
  { id: 'fixed-logistic-services', label: 'Logistics', email: 'bash@fixedlogistic.com', description: 'Refrigerated haulage and transport enquiries.' },
  { id: 'fixed-chiller-freezer', label: 'Chiller & Freezer', email: 'bash@fixedchiller.com', description: 'Reefer servicing and monitoring enquiries.' },
  { id: 'fixed-borneo-reefer', label: 'Borneo Reefer', email: 'bash@fixedborneo.com', description: 'Reefer repairs, leasing and cold room enquiries.' }
].map(team => ({ ...team, name: DIVISIONS.find(division => division.slug === team.id).name }));

export const getEnquiryTeam = id => ENQUIRY_TEAMS.find(team => team.id === id) || ENQUIRY_TEAMS[0];

export function getEnquiryRequest(form) {
  const team = getEnquiryTeam(form.team);
  // Resolve recipients only from the fixed list above, never from URL parameters or form text.
  return {
    endpoint: `https://formsubmit.co/ajax/${team.email}`,
    payload: {
      name: form.name.trim(),
      email: form.email.trim(),
      phone: form.phone.trim(),
      company: form.company.trim(),
      location: form.location.trim(),
      service: form.service,
      subject: form.subject.trim(),
      message: form.message.trim(),
      enquiry_team: team.name,
      _cc: ADMIN_CONTACTS.map(contact => contact.email).join(','),
      _replyto: form.email.trim(),
      _subject: `Fixed Group enquiry — ${team.name}`,
      _template: 'table',
      _captcha: 'false'
    }
  };
}

export function getEnquiryMailto(teamId, form) {
  const team = getEnquiryTeam(teamId);
  const fields = form ? [
    ['Name', form.name], ['Email', form.email], ['Phone', form.phone],
    ['Company', form.company], ['Project location', form.location],
    ['Service', form.service], ['Subject', form.subject]
  ].filter(([, value]) => value) : [];
  const body = form
    ? [...fields.map(([label, value]) => `${label}: ${value}`), '', form.message || 'Please tell us about your requirement.'].join('\r\n')
    : `Hello ${team.name},\r\n\r\nI would like to enquire about your services.\r\n`;
  const params = {
    cc: ADMIN_CONTACTS.map(contact => contact.email).join(','),
    subject: `Fixed Group enquiry — ${team.name}`,
    body
  };
  return `mailto:${team.email}?${Object.entries(params).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')}`;
}
